function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddcard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.74 14.4385H8.73999",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 11.998V16.998",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1382 1.51814L12.1082 1.58814L9.20823 8.31814H6.35823C5.67823 8.31814 5.02823 8.45814 4.43823 8.70814L6.18823 4.52814L6.22823 4.42814L6.29823 4.26814C6.31823 4.20814 6.33823 4.14814 6.36823 4.09814C7.67823 1.06814 9.15823 0.378136 12.1382 1.51814Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5283 8.51807C17.0783 8.37807 16.5983 8.31807 16.1183 8.31807H9.20825L12.1083 1.58807L12.1383 1.51807C12.2883 1.56807 12.4283 1.63807 12.5783 1.69807L14.7883 2.62807C16.0183 3.13807 16.8783 3.66807 17.3983 4.30807C17.4983 4.42807 17.5783 4.53807 17.6483 4.66807C17.7383 4.80807 17.8083 4.94807 17.8483 5.09807C17.8883 5.18807 17.9183 5.27807 17.9383 5.35807C18.2083 6.19807 18.0483 7.22807 17.5283 8.51807Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.1984V15.1484C21 15.3484 20.99 15.5484 20.98 15.7484C20.79 19.2384 18.84 20.9984 15.14 20.9984H7.33999C7.09999 20.9984 6.85999 20.9784 6.62999 20.9484C3.44999 20.7384 1.74999 19.0384 1.53999 15.8584C1.50999 15.6284 1.48999 15.3884 1.48999 15.1484V13.1984C1.48999 11.1884 2.70999 9.45836 4.44999 8.70836C5.04999 8.45836 5.68999 8.31836 6.36999 8.31836H16.13C16.62 8.31836 17.1 8.38836 17.54 8.51836C19.53 9.12836 21 10.9884 21 13.1984Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.18827 4.52808L4.43827 8.70808C2.69827 9.45808 1.47827 11.1881 1.47827 13.1981V10.2681C1.47827 7.42808 3.49827 5.05808 6.18827 4.52808Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9969 10.2677V13.1977C20.9969 10.9977 19.5369 9.12766 17.5369 8.52766C18.0569 7.22766 18.2069 6.20766 17.9569 5.35766C17.9369 5.26766 17.9069 5.17766 17.8669 5.09766C19.7269 6.05766 20.9969 8.02766 20.9969 10.2677Z",
    stroke: "#292D32",
    style: {
      stroke: "#292D32",
      stroke: "color(display-p3 0.1608 0.1765 0.1961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddcard2);
export default __webpack_public_path__ + "static/media/addcard2.edff9792380117fcf87ccfd3dca76d0d.svg";
export { ForwardRef as ReactComponent };